var $0e28f2b8b6d36dfd$exports = {};
$0e28f2b8b6d36dfd$exports = {
    "collectionLabel": `N\xe1vrhy`
};


export {$0e28f2b8b6d36dfd$exports as default};
//# sourceMappingURL=cs-CZ.mjs.map
